import { render, staticRenderFns } from "./NotifyList.vue?vue&type=template&id=0c96d32c&scoped=true&"
import script from "./NotifyList.vue?vue&type=script&lang=js&"
export * from "./NotifyList.vue?vue&type=script&lang=js&"
import style0 from "./NotifyList.vue?vue&type=style&index=0&id=0c96d32c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c96d32c",
  null
  
)

export default component.exports